import List from '../components/list.js';
import { useState, useContext, useEffect } from 'react';
import Context from '../components/context.js';
import { AccessContext } from '../components/context.js';
import { Link } from 'react-router-dom';
import axios from 'axios';

const EventList = () => {
    const [events, setEvents] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(true);
    const setContext = useContext(Context)[1];
    const { role, metaData } = useContext(AccessContext);
    const [checks, setChecks] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    setContext('Events');
    var headings = [
        { key: 'id', name: 'ID' },
        { key: 'title', name: 'Name', link: true, linkKey: 'id' },
        { key: 'active', name: 'Status', center: true },
        { key: 'location', name: 'Location' },
        { key: 'date', name: 'Date' },
    ];
    if (role == 'Host/Guest') {
        headings = [
            { key: 'id', name: 'ID' },
            { key: 'title', name: 'Name', link: true, linkKey: 'id' },
            { key: 'location', name: 'Location' },
            { key: 'date', name: 'Date' },
        ];
    }
    useEffect(() => {
        if (role == 'Host/Guest')
            loadEvents();
    }, [role])
    const loadEvents = (page) => {
        setLoading(true);
        if (role == "Host/Guest") {
            axios.post(process.env.REACT_APP_API_URL + 'host', {
                id: metaData.speakerId
            }).then(r => {
                setLoading(false);
                if (r?.data?.status === 'Success') {
                    var now = new Date();
                    var filteredEvents = r.data.results?.events?.map(res => {
                        return {
                            id: res.id,
                            title: res.title,
                            location: res.location,
                            isActive: !!res.active,
                            active: res.active ? <span style={{color: 'green'}}>{'\u2714'}</span> : <span style={{color: 'red'}}>{'\u2716'}</span>,
                            date: (new Date(res.datetime)).toLocaleDateString()
                        }
                    }).filter(a => {
                        return new Date(a.date) >= now && a.title.includes(search);
                    });
                    setTotalRecords(filteredEvents?.length);
                    setEvents(filteredEvents);
                }
            });
            return;
        }
        axios.post(process.env.REACT_APP_API_URL + 'event', {
            page: page,
            search: search
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                setTotalRecords(r.data.total);
                setEvents(r.data.results?.map(res => {
                    return {
                        id: res.id,
                        title: res.title,
                        location: res.location,
                        isActive: !!res.active,
                        active: res.active ? <span style={{color: 'green'}}>{'\u2714'}</span> : <span style={{color: 'red'}}>{'\u2716'}</span>,
                        date: (new Date(res.datetime)).toLocaleDateString()
                    }
                }));
            }
        });
    }
    const deleteEvents = () => {
        let ids = checks.reduce((acc, cur, i) => {
            if (cur) {
                acc.push(events[i].id);
            }
            return acc
        }, []);
        if (!ids?.length)
            return;
        axios.post(process.env.REACT_APP_API_URL + 'event/delete', {
            ids: ids
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                loadEvents(currentPage);
                setChecks(Array.apply(null, Array(events?.length)).map(() => false));
            }
        });
    }
    const addEventsToPodcast = () => {
        let ids = checks.reduce((acc, cur, i) => {
            if (cur) {
                acc.push(events[i].id);
            }
            return acc
        }, []);
        if (!ids?.length)
            return;
        axios.post(process.env.REACT_APP_API_URL + 'event/update/podcast-connection', {
            ids: ids,
            add: true
        }).then(r => {
            setLoading(false);
            loadEvents(currentPage);
            setChecks(Array.apply(null, Array(events?.length)).map(() => false));
        });
    }
    const removeEventsFromPodcast = () => {
        let ids = checks.reduce((acc, cur, i) => {
            if (cur) {
                acc.push(events[i].id);
            }
            return acc
        }, []);
        if (!ids?.length)
            return;
        axios.post(process.env.REACT_APP_API_URL + 'event/update/podcast-connection', {
            ids: ids,
            add: false
        }).then(r => {
            setLoading(false);
            loadEvents(currentPage);
            setChecks(Array.apply(null, Array(events?.length)).map(() => false));
        });
    }
    useEffect(() => {
        loadEvents(0);
    }, []);
    useEffect(() => {
        setChecks(Array.apply(null, Array(events?.length)).map(() => false));
    }, [events]);
    const pageSize = 20;
    var pages = [];
    for (var i = Math.max(0, currentPage - 3); i < Math.min(currentPage + 4, Math.ceil(totalRecords / pageSize)); i++) {
        pages.push(i);
    }
    return (
        <main>
            <div className="container w-100">
                <div className="form mb-10">
                    <div className="w-100 f-row gap-10">
                        <Link to="/event" className="btn btn-green">Add Event</Link>
                    </div>
                    <div className="mw-300 w-100 gap-15 f-row">
                        <button className="link-styles" onClick={deleteEvents}>Delete</button>
                        {role != "Host/Guest" && (
                            <>
                                <button className="link-styles" style={{whiteSpace: 'nowrap'}} onClick={addEventsToPodcast}>Publish</button>
                                <button className="link-styles" style={{whiteSpace: 'nowrap'}} onClick={removeEventsFromPodcast}>Unpublish</button>
                            </>
                        )}
                    </div>
                    <div className="mw-300 w-100 ml-auto gap-10 f-row f-end">
                        <input type="search" placeholder="Search Events" value={search} onChange={(e) => setSearch(e.target.value)} />
                        <button className="btn" onClick={() => { setCurrentPage(0); loadEvents(0)}}> Search</button>
                    </div>
                </div>
                <List list={events || []} actions={role == "Host/Guest" ? undefined : [{
                    text: (e) => {
                        return !e.isActive ? 'Publish' : 'Unpublish'
                    },
                    action: (e) => {
                        axios.post(process.env.REACT_APP_API_URL + 'event/update/podcast-connection', {
                            ids: [e.id],
                            add: !e.isActive
                        }).then(r => {
                            setLoading(false);
                            loadEvents(currentPage);
                        });
                    }
                }]} href="event" headings={headings} loading={loading} onCheck={setChecks} />
                {role != "Host/Guest" && (
                    <div className="list-arrows">
                        {currentPage > 0 && (
                            <button className="btn btn-square btn-arrow" onClick={() => {
                                loadEvents(currentPage - 1);
                                setCurrentPage(c => c - 1);
                            }}>{'\u2039'}</button>
                        )}
                        {pages.map(p => (
                            <button key={p} className={"btn btn-squared" + (p == currentPage ? ' current-page' : '')} onClick={() => {
                                loadEvents(p);
                                setCurrentPage(p);
                            }}>{p + 1}</button>
                        ))}
                        {(currentPage + 1) * pageSize < totalRecords - 1 && (
                            <button className="btn btn-square btn-arrow" onClick={() => {
                                loadEvents(currentPage + 1);
                                setCurrentPage(c => c + 1);
                            }}>{'\u203A'}</button>
                        )}
                    </div>
                )}
            </div>
        </main>
    )
}

export default EventList;